import productFlags from '../search/product/components/product-flags';
import productImage from '../search/product/components/product-image';
import productSizeWrapper from '../search/product/components/tile-box/product-size-wrapper';
import productWishlistIcon from '../search/product/components/product-wishlist-icon';
import productRecommendationInfo from './recommendation-product-info';

/**
 * @param {Object} product - product
 * @param {number} index - product index
 * @param {boolean} showFlags - show flags
 * @returns {string} product tile HTML
 */
export default (product, index, showFlags) => {
    let wishlistLink = product.isInWishlist ? Urls.WISHLIST_REMOVE : Urls.WISHLIST_ADD;
    wishlistLink += `?pid=${product.ID}&source=plp`;
    return `
        <div class="product-slick">
            <!-- dwMarker="product" dwContentID="${product.UUID}" -->
            <div class="${index % 4 === 0 ? ' first-when-4-in-row' : ''} ${
        index % 3 === 0 ? ' first-when-3-in-row' : ''
    } ${index % 2 === 0 ? ' first-when-2-in-row' : ''}" data-index="${index}"
                data-cnstrc-item="Recommendation"
                data-cnstrc-item-id="${product.ID}"
                data-cnstrc-item-name="${product.name}"
                data-cnstrc-item-variation-id="${product.variationId}"
                data-cnstrc-strategy-id="${product.strategyId}"
            >
                <a class="product-tile has-hover-effect"
                    id="${product.UUID}" data-itemid="${product.ID}" href="${product.url}"
                    data-variantsids="${product.variationsMap?.join('|') || ''}" 
                    title="${product.name}">
                        ${productWishlistIcon(product, wishlistLink)}
                        ${showFlags ? productFlags(product.flags, 'clp') : ''}
                        ${productImage(product, product.swatches?.length > 0)}
                        <div class="tile-box">
                            ${productRecommendationInfo(product)}
                            ${productSizeWrapper(product)}
                            <div class="product-tile-hover-view">
                            </div>
                        </div>
                </a>
            </div>
        </div>
    `;
};
